import { createTheme } from '@mui/material/styles';

// Paleta: verde WhatsApp como acento, base oscura/limpia.
export const theme = createTheme({
  palette: {
    primary: { main: '#25D366', dark: '#128C7E', contrastText: '#ffffff' },
    secondary: { main: '#075E54' },
    background: { default: '#F0F2F5', paper: '#ffffff' },
    success: { main: '#10B981' },
    warning: { main: '#F59E0B' },
    error: { main: '#EF4444' },
    info: { main: '#3B82F6' },
    text: { primary: '#1E293B', secondary: '#64748B' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @keyframes respFloat {
          0% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0); }
        }
        @keyframes respFadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes respPulse {
          0% { box-shadow: 0 0 0 0 rgba(37,211,102,0.45); }
          70% { box-shadow: 0 0 0 14px rgba(37,211,102,0); }
          100% { box-shadow: 0 0 0 0 rgba(37,211,102,0); }
        }
        @keyframes respBlob {
          0%,100% { border-radius: 42% 58% 63% 37% / 42% 42% 58% 58%; }
          50% { border-radius: 58% 42% 37% 63% / 58% 58% 42% 42%; }
        }
        .resp-float { animation: respFloat 5s ease-in-out infinite; }
        .resp-fade-up { animation: respFadeUp .7s ease both; }
        .resp-pulse { animation: respPulse 2.2s infinite; }
      `,
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          borderRadius: 14,
          transition: 'transform .25s ease, box-shadow .25s ease',
          '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 28px rgba(0,0,0,0.12)' },
        },
      },
    },
    MuiButton: { defaultProps: { disableElevation: true } },
    // ─── Responsive global ─────────────────────────────────────────────────
    // Todas las tablas pueden hacer scroll horizontal en móvil sin romper el layout.
    MuiTableContainer: {
      styleOverrides: {
        root: { overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
      },
    },
    // Los diálogos ocupan casi toda la pantalla en móvil (márgenes chicos).
    MuiDialog: {
      styleOverrides: {
        paper: {
          '@media (max-width:600px)': {
            margin: 12,
            width: 'calc(100% - 24px)',
            maxWidth: 'calc(100% - 24px)',
          },
        },
      },
    },
    // Títulos de página más chicos en móvil para que no se corten.
    MuiTypography: {
      styleOverrides: {
        h4: { '@media (max-width:600px)': { fontSize: '1.5rem' } },
        h5: { '@media (max-width:600px)': { fontSize: '1.25rem' } },
      },
    },
  },
});
